import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=29c7337c&scoped=true&"
import script from "./StartScreen.vue?vue&type=script&lang=js&"
export * from "./StartScreen.vue?vue&type=script&lang=js&"
import style0 from "./StartScreen.vue?vue&type=style&index=0&id=29c7337c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c7337c",
  null
  
)

export default component.exports